import React, { useEffect, useState } from 'react';
import { useLocalStorage } from 'usehooks-ts';
import axios from '../../axios-base';
import { checkValidity } from '../../shared/utility';
import Input from '../../components/UI/Input/FormInput';
import { Button, Col } from 'reactstrap';
import Cookies from 'js-cookie';
import { useHistory, useParams, Link } from 'react-router-dom';
import WafCaptcha from '../../components/WafCaptcha/WafCaptcha';

function SMSVote(props) {
    const [votingButton, setVotingButton] = useState('Jetzt per SMS abstimmen!');
    const [votingReady, setVotingReady] = useState(false);
    const [SMSCodeConfig, setSMSCodeConfig] = useState({
        elementType: 'input',
        elementConfig: {
            type: 'text',
            inputMode: 'text',
            placeholder: 'Beispiel: PKX8QKZ8',
            label: 'Ihr SMS-Code zur Stimmabgabe',
            columns: 12,
            disabled: false,
        },
        value: '',
        validation: {
            required: { value: true, errorMessage: 'Bitte geben Sie einen gültige SMS Code an' },
            isSMSCode: { value: true, errorMessage: 'Bitte geben Sie einen gültige SMS Code an' },
            maxLength: { value: 8, errorMessage: 'Bitte geben Sie einen gültige SMS Code an.' },
            minLength: { value: 8, errorMessage: 'Bitte geben Sie einen gültige SMS Code an' },
        },
        valid: false,
        errorMessage: 'Bitte geben Sie eine gültigen SMS-Code an',
        helperText: 'Bitte Ihren 8-stelligen SMS-Code eingeben.',
        validMessage: 'Jetzt Code verwenden',
        touched: false,
        ifAuth: false,
    });
    const [voteButtonVisibility, setVoteButtonVisibility] = useState(true);
    const [captchaContainerVisibility, setCaptchaContainerVisibility] = useState(false);

    let history = useHistory();
    const { id } = useParams();
    useEffect(() => {
        if (props.projectCategory) {
            Cookies.set('bigfoot_redirect-category', props.projectCategory, { expires: 180 });
        }
    }, [props.projectCategory]);

    const [webOtpCode, , removeWebOtpCode] = useLocalStorage('webOtpCode', null);

    useEffect(() => {
        if (!webOtpCode) return;
        onChangeHandler({ target: { value: webOtpCode } });
    }, [webOtpCode]); // eslint-disable-line react-hooks/exhaustive-deps

    const onChangeHandler = (event) => {
        const userInput = event.target.value.toUpperCase();

        const updatedSMSCode = {
            ...SMSCodeConfig,
        };

        updatedSMSCode.value = userInput;
        let validity = checkValidity(updatedSMSCode.value, updatedSMSCode.validation);
        updatedSMSCode.valid = validity.isValid;
        updatedSMSCode.errorMessage = validity.errorMessage ?? '';
        updatedSMSCode.touched = true;

        let updatedVotingReady = updatedSMSCode.valid;
        setSMSCodeConfig(updatedSMSCode);
        setVotingReady(updatedVotingReady);

        if (updatedVotingReady) {
            setVotingButton('Jetzt per SMS abstimmen!');
        }
    };

    const onVoteHandler = () => {
        smsVote();

        // Consume the code so it is not re-applied on subsequent renders
        removeWebOtpCode();
    };

    const smsVote = () => {
        let fetchPromise = axios.patch(
            '/sms',
            {
                code: SMSCodeConfig.value,
                projectId: id,
            },
            { wafProtected: true }
        );

        fetchPromise
            .then((response) => {
                if (response.status === 200) {
                    let updatedSMSCode = { ...SMSCodeConfig };
                    updatedSMSCode.elementConfig.disabled = true;
                    setVotingReady(false);
                    setVotingButton('Sie haben bereits abgestimmt');
                    setSMSCodeConfig(updatedSMSCode);

                    Cookies.set('survey-answer-id', response.data.surveyAnswerId, { expires: 7 });
                    Cookies.remove('bigfoot_code-requested');
                    history.push({
                        pathname: '/stimme-bestaetigt',
                        state: response.data.surveyAnswerId,
                    });
                } else {
                    handleUnsuccessfulSMSRequest(response);
                }
            })
            .catch((err) => {
                if (err.response && err.response.status === 405) {
                    //hide sms request button
                    setVoteButtonVisibility(false);
                    displayCaptchaPuzzle();
                } else {
                    handleUnsuccessfulSMSRequest(err);
                }
            });
    };

    const displayCaptchaPuzzle = () => {
        setCaptchaContainerVisibility(true);
    };

    const onCaptchaVerified = () => {
        //Called on Successful Captcha
        //Hide captcha success message to remove confusion in voting process
        // Display voting button as animation progress and redirect are shown within it
        setVoteButtonVisibility(true);
        setCaptchaContainerVisibility(false);
        onVoteHandler();
    };

    const handleUnsuccessfulSMSRequest = (responseOrError) => {
        // Check if it's a fetch response or an error object
        if (responseOrError instanceof Response) {
            // Handle fetch Response object
            responseOrError
                .text()
                .then((responseText) => {
                    setVotingReady(false);
                    setVotingButton('Nicht erfolgreich');
                })
                .catch((err) => {
                    setVotingReady(false);
                    setVotingButton('Nicht erfolgreich');
                });
        } else {
            setVotingReady(false);
            setVotingButton('Nicht erfolgreich');
        }
    };

    let form = (
        <>
            <Input
                wrapperCSSClass="px-0 mb-1"
                type={SMSCodeConfig.elementType}
                name="SMSCode"
                id="SMSCode"
                autoComplete="one-time-code"
                placeholder={SMSCodeConfig.elementConfig.placeholder}
                elementType={SMSCodeConfig.elementType}
                elementConfig={SMSCodeConfig.elementConfig}
                value={SMSCodeConfig.value}
                changed={(event) => onChangeHandler(event)}
                shouldValidate={SMSCodeConfig.validation}
                touched={SMSCodeConfig.touched}
                errorMessage={SMSCodeConfig.errorMessage}
                helperText={SMSCodeConfig.helperText}
                validMessage={SMSCodeConfig.validMessage}
                invalid={!SMSCodeConfig.valid}
                formText={SMSCodeConfig.formText}
            />
        </>
    );

    return (
        <Col>
            {form}
            <WafCaptcha show={captchaContainerVisibility} onVerified={onCaptchaVerified} />
            {voteButtonVisibility && (
                <>
                    <Button
                        className={votingReady ? 'anl_sms--vote' : null}
                        disabled={!votingReady}
                        block
                        color="primary"
                        onClick={() => onVoteHandler()}
                    >
                        {votingButton}
                    </Button>
                    <Link
                        to="/code-anfordern"
                        className="anl_sms--redirect-request"
                        style={{ marginTop: '0.5em', marginBottom: '0.75em', display: 'block' }}
                    >
                        <Button
                            style={{ cursor: 'pointer' }}
                            className="w-100"
                            role="button"
                            color="primary"
                            outline={true}
                        >
                            Ihren SMS-Code anfordern!
                        </Button>
                    </Link>
                </>
            )}
        </Col>
    );
}

export default SMSVote;
